/**
 * TanStack Query hooks for `order-recovery-workflow`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	orderRecoveryWorkflowQueryKeys,
	type CreateOrderRecoveryWorkflowBody,
	type ListOrderRecoveryWorkflowResponse,
	type OrderRecoveryWorkflowRow,
} from "./api";

export function useOrderRecoveryWorkflowList(): UseQueryResult<ListOrderRecoveryWorkflowResponse, Error> {
	return useQuery({
		queryKey: orderRecoveryWorkflowQueryKeys.list(),
		queryFn: list,
	});
}

export function useOrderRecoveryWorkflowCreate(): UseMutationResult<OrderRecoveryWorkflowRow, Error, CreateOrderRecoveryWorkflowBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: orderRecoveryWorkflowQueryKeys.all });
		},
	});
}

export function useOrderRecoveryWorkflowDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: orderRecoveryWorkflowQueryKeys.all });
		},
	});
}
